import { forwardRef } from 'react';

import { styled } from '@spazious/dollhouse-theme';

import { Flex, FlexElement, FlexProps } from '../Flex/index.js';

const shadows = [
  'none',
  '0 1px 3px 0 rgba(0, 0, 0, 0.06), 0 1px 2px 0 rgba(0, 0, 0, 0.12)',
  '0 3px 6px 0 rgba(0, 0, 0, 0.08), 0 3px 6px 0 rgba(0, 0, 0, 0.16)',
  '0 10px 20px 0 rgba(0, 0, 0, 0.10), 0 6px 6px 0 rgba(0, 0, 0, 0.20)',
  '0 14px 28px 0 rgba(0, 0, 0, 0.12), 0 10px 10px 0 rgba(0, 0, 0, 0.24)',
  '0 19px 38px 0 rgba(0, 0, 0, 0.16), 0 15px 12px 0 rgba(0, 0, 0, 0.32)',
  '0 25px 50px 0 rgba(0, 0, 0, 0.20), 0 20px 15px 0 rgba(0, 0, 0, 0.40)',
  '0 35px 60px 0 rgba(0, 0, 0, 0.24), 0 25px 20px 0 rgba(0, 0, 0, 0.48)',
  '0 40px 80px 0 rgba(0, 0, 0, 0.28), 0 30px 25px 0 rgba(0, 0, 0, 0.56)',
  '0 50px 100px 0 rgba(0, 0, 0, 0.32), 0 35px 30px 0 rgba(0, 0, 0, 0.64)',
  '0 60px 120px 0 rgba(0, 0, 0, 0.36), 0 40px 35px 0 rgba(0, 0, 0, 0.72)',
  '0 70px 140px 0 rgba(0, 0, 0, 0.40), 0 45px 40px 0 rgba(0, 0, 0, 0.80)',
];

export type PaperElement = FlexElement;

export interface PaperProps extends FlexProps {
  elevation?: number;
}

export const Paper = styled(
  forwardRef<PaperElement, PaperProps>(
    ({ elevation = 1, borderRadius = '0.5rem', backgroundColor = '#fff', ...restProps }) => {
      return (
        <Flex
          backgroundColor={backgroundColor}
          borderRadius={borderRadius}
          boxShadow={shadows[elevation]}
          {...restProps}
        />
      );
    }
  )
).withConfig({
  displayName: 'Paper',
})``;
